
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authorized-center/[...slug]",
      function () {
        return require("private-next-pages/authorized-center/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authorized-center/[...slug]"])
      });
    }
  